<template>
  <el-dropdown :class="[style.dropdown, border ? '' : style.noborder, `dropdown-${props.size}`, props.filled ? `dropdown-filled` : '',]" :popper-class="`${style.popper} dropdown-popper-${props.size}`" aria-hide="true">
    <span :class="['inline-flex-row items-center cursor-pointer gap-4',style.text]">
      <template v-for="(item) in options">
        <template v-if="item.value == value">{{ item.label || item.text }}</template>
      </template>
      <SvgIcon style="width:1em;height:1em" icon="12-Filled-PullUp" :class="style.arrow" />
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="item in options" :key="item.value" :class="[item.value == value ? 'selected' : '']"
          @click="onClick(item.value)"
        >
          {{ item.label || item.text }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup lang="ts">
const props = defineProps({
  value: {
    type: [String, Number],
    default: ''
  },
  size: {
    validator(value: string) {
      return ['max', 'large', 'default', 'small', 'mini'].indexOf(value) > -1;
    },
    type: String,
    default: 'default'
  },
  options: {
    type: Array,
    default: () => []
  },
  filled: {
    type: Boolean,
    default: false
  },
  border: {
    type: Boolean,
    default: true
  }
});
const emit = defineEmits(['update:value', 'change']);

const onClick = (val: any) => {
  if (val != props.value) {
    emit('update:value', val);
    emit('change', val);
  }
};

</script>

<style lang="scss" module="style">
.dropdown {
  --el-text-color-regular: var(--text-text1);
  --el-input-border-color: var(--gray-gray2);
  box-shadow: 0 0 0 1px var(--el-input-border-color) inset;
  padding: 0 15px;
  border-radius: var(--el-border-radius-base);
  font-size: var(--font-size) ;
  font-weight: var(--font-weight) ;
  height: var(--dropdown-height);

  &:hover {
    --el-select-border-color-hover: var(--gray-gray10);
  }

  :global(.el-input__wrapper) {
    --el-select-input-focus-border-color: var(--gray-gray10);
    --el-input-border-color: var(--gray-gray2);
  }

  :global(.el-input__inner::placeholder) {
    color: var(--text-text4);
  }
}

.text {
  &[aria-expanded="true"] svg {
    transform: rotate(-180deg);
  }
}

.noborder {
    box-shadow: none;
}

:global {
  .dropdown {

    &-max {
      --el-border-radius-base: var(--radius-max);
      --dropdown-height: var(--height-max);
      --font-size: var(--font-size-max);
      --font-weight: var(--font-weight-max)
    }

    &-large {
      --el-border-radius-base: var(--radius-large);
      --dropdown-height: var(--height-large);
      --font-size: var(--font-size-large);
      --font-weight: var(--font-weight-large)
    }

    &-default {
      --el-border-radius-base: var(--radius-default);
      --dropdown-height: var(--height-default);
      --font-size: var(--font-size-default);
      --font-weight: var(--font-weight-default)
    }

    &-small {
      --el-border-radius-base: var(--radius-small);
      --dropdown-height: var(--height-small);
      --font-size: var(--font-size-small);
      --font-weight: var(--font-weight-small);
      padding:0 8px;
    }
    &-mini {
      --el-border-radius-base: var(--radius-mini);
      --dropdown-height: var(--height-mini);
      --font-size: var(--font-size-mini);
      --font-weight: var(--font-weight-mini);
      padding:0 8px;
    }

    &-filled {
      --el-input-border-color: var(--fill-fill2);
      background: var(--fill-fill2);
    }
  }

  .dropdown-popper{
    &-max {
      --el-border-radius-base: var(--radius-max);
      --el-popper-border-radius: var(--radius-max);
    }

    &-large {
      --el-border-radius-base: var(--radius-large);
      --el-popper-border-radius: var(--radius-max);
    }

    &-default {
      --el-border-radius-base: var(--radius-default);
      --el-popper-border-radius: var(--radius-max);
    }

    &-small {
      --el-border-radius-base: var(--radius-small);
      --el-popper-border-radius: var(--radius-max);
    }
    &-mini {
      --el-border-radius-base: var(--radius-mini);
      --el-popper-border-radius: var(--radius-max);
    }
  }
  
}

.popper{
  --el-dropdown-menuItem-hover-fill: var(--fill-fill4);
  --el-dropdown-menuItem-hover-color: var(--text-text1);
  --el-border-color-light:var(--border-border1);
  --el-bg-color-overlay:var(--base-base1);
  :global{
    .el-dropdown-menu__item{
      color: var(--text-text2);
    }
    .el-dropdown-menu{
      overflow: hidden;
      border-radius: var(--el-popper-border-radius);
    }
    .el-scrollbar__wrap{
      max-height: 200px;
    }
    .el-dropdown-menu__item.selected{
      color: var(--text-text1);
      font-weight: 500;
    }
  }
}
</style>
